export default "__VITE_ASSET__BdANCXXX__"